import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsUpLg = (): boolean =>
  useMediaQuery(useTheme().breakpoints.up('lg'));
